module.exports = __webpack_public_path__ + "static/img/jpeg.39b040b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat_files/jpeg.png
// module id = Krat
// module chunks = 4